export const TextAndType = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => <svg aria-hidden="true" className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="TextAndType" data-sentry-source-file="text-and-type.tsx">
    <path d="M15 18H3M17 6H3M21 12H3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-sentry-element="path" data-sentry-source-file="text-and-type.tsx" />
  </svg>;